"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
const abi_1 = require("./abi");
const address_1 = require("./address");
const constants_1 = require("./constants");
const serializationcommon_1 = require("./serializationcommon");
const atomicswapcontract_1 = require("./smartcontracts/atomicswapcontract");
class AtomicSwapContractTransactionBuilder {
    static buildTransaction(input, erc20Tokens, chainId, value, fee, signerPubkey, atomicSwapContractAddress, prefix) {
        const positionMethodIdBegin = 0;
        const positionMethodIdEnd = positionMethodIdBegin + 4;
        const positionSwapIdBegin = positionMethodIdEnd;
        const positionSwapIdEnd = positionSwapIdBegin + 32;
        const method = atomicswapcontract_1.AtomicSwapContract.abiDecodeMethodId(input.slice(positionMethodIdBegin, positionMethodIdEnd));
        const swapIdWithoutPrefix = {
            data: input.slice(positionSwapIdBegin, positionSwapIdEnd),
        };
        switch (method) {
            case atomicswapcontract_1.SwapContractMethod.Open: {
                const positionRecipientBegin = positionSwapIdEnd;
                const positionRecipientEnd = positionRecipientBegin + 32;
                const positionHashBegin = positionRecipientEnd;
                const positionHashEnd = positionHashBegin + 32;
                const positionTimeoutBegin = positionHashEnd;
                const positionTimeoutEnd = positionTimeoutBegin + 32;
                const positionErc20ContractAddressBegin = positionTimeoutEnd;
                const positionErc20ContractAddressEnd = positionErc20ContractAddressBegin + 32;
                const positionAmountBegin = positionErc20ContractAddressEnd;
                const positionAmountEnd = positionAmountBegin + 32;
                const recipientAddress = abi_1.Abi.decodeAddress(input.slice(positionRecipientBegin, positionRecipientEnd));
                const hash = input.slice(positionHashBegin, positionHashEnd);
                const timeoutHeight = new bn_js_1.default(input.slice(positionTimeoutBegin, positionTimeoutEnd)).toNumber();
                const erc20ContractAddressBytes = input.slice(positionErc20ContractAddressBegin, positionErc20ContractAddressEnd);
                const token = erc20ContractAddressBytes.length
                    ? [...erc20Tokens.values()].find((t) => t.contractAddress.toLowerCase() ===
                        abi_1.Abi.decodeAddress(erc20ContractAddressBytes).toLowerCase())
                    : null;
                const fractionalDigits = token ? token.decimals : constants_1.constants.primaryTokenFractionalDigits;
                const tokenTicker = token ? token.symbol : constants_1.constants.primaryTokenTicker;
                const quantity = token
                    ? abi_1.Abi.decodeUint256(input.slice(positionAmountBegin, positionAmountEnd))
                    : value;
                return {
                    kind: "bcp/swap_offer",
                    chainId: chainId,
                    swapId: Object.assign(Object.assign({}, swapIdWithoutPrefix), { prefix: token ? serializationcommon_1.SwapIdPrefix.Erc20 : serializationcommon_1.SwapIdPrefix.Ether }),
                    fee: fee,
                    amounts: [
                        {
                            quantity: quantity,
                            fractionalDigits: fractionalDigits,
                            tokenTicker: tokenTicker,
                        },
                    ],
                    sender: address_1.pubkeyToAddress(signerPubkey),
                    recipient: recipientAddress,
                    timeout: {
                        height: timeoutHeight,
                    },
                    hash: hash,
                };
            }
            case atomicswapcontract_1.SwapContractMethod.Claim: {
                const positionPreimageBegin = positionSwapIdEnd;
                const positionPreimageEnd = positionPreimageBegin + 32;
                const preimage = input.slice(positionPreimageBegin, positionPreimageEnd);
                return {
                    kind: "bcp/swap_claim",
                    chainId: chainId,
                    fee: fee,
                    swapId: Object.assign(Object.assign({}, swapIdWithoutPrefix), { prefix: prefix }),
                    preimage: preimage,
                };
            }
            case atomicswapcontract_1.SwapContractMethod.Abort: {
                return {
                    kind: "bcp/swap_abort",
                    chainId: chainId,
                    fee: fee,
                    swapId: Object.assign(Object.assign({}, swapIdWithoutPrefix), { prefix: prefix }),
                };
            }
            default:
                throw new Error("Atomic swap method not recognized");
        }
    }
}
exports.AtomicSwapContractTransactionBuilder = AtomicSwapContractTransactionBuilder;
//# sourceMappingURL=atomicswapcontracttransactionbuilder.js.map